import { Quotation, Stars } from '@components/common/icons/custom-icons'
import { FastlyImage } from '@components/common/image'

type Props = {
  name: string
  image: string
  darkText?: string
  subHeading: string
  rating: string
  content: string
  size?: number
}

const TestimonialCard = ({
  name,
  darkText,
  image,
  subHeading,
  content,
  size,
  rating,
}: Props) => {
  return (
    <div className="bg-white relative px-4 py-8 rounded-md shadow-lg h-full">
      <div className="flex items-center space-x-5">
        <div className="absolute top-0 left-0 w-8 mt-2 ml-2">
          <Quotation />
        </div>
        <div>
          <FastlyImage
            src={image}
            alt={name}
            width={size ?? 127}
            height={size ?? 144}
          />
        </div>
        <div className="flex flex-col items-start">
          <span className="text-xl capitalize font-700">{name}</span>
          {darkText && <span className="mb-2 text-gray-200">{darkText}</span>}
          <span
            className="inline-block px-2 rounded-md text-grey mb-2"
            style={{
              backgroundColor: '#E0E3FD',
            }}
          >
            {subHeading}
          </span>
          <Stars allStars={rating === '5'} />
        </div>
      </div>
      <span className="inline-block w-full h-1 border-b border-grey-300"></span>

      <p className="pt-6 text-lg leading-tight font-600">{content}</p>
    </div>
  )
}

export default TestimonialCard
